import React, { createContext, useContext, useState, useEffect } from 'react';
import axiosInstance from '../lib/axios';
import { useAuth } from './AuthContext';

const PermissionContext = createContext();

export const usePermissions = () => {
  const context = useContext(PermissionContext);
  if (!context) {
    throw new Error('usePermissions must be used within PermissionProvider');
  }
  return context;
};

export const PermissionProvider = ({ children }) => {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchRolePermissions();
    } else {
      setPermissions({});
      setLoading(false);
    }
  }, [user]);

  const fetchRolePermissions = async () => {
    try {
      // Use new /me/permissions endpoint that works for all users
      const response = await axiosInstance.get('/me/permissions');
      setPermissions(response.data.permissions || {});
    } catch (error) {
      console.error('Failed to fetch permissions:', error);
      setPermissions({});
    } finally {
      setLoading(false);
    }
  };

  const hasPermission = (permission) => {
    return permissions[permission] === true;
  };

  const value = {
    permissions,
    hasPermission,
    loading
  };

  return (
    <PermissionContext.Provider value={value}>
      {children}
    </PermissionContext.Provider>
  );
};
